export default {
  functions: [
    {
      name: 'getPDPProduct',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'pdpProduct',
      },
    },
  ],
};
